export default {
	"number": {
		"platformName": "แพลตฟอร์มการติดตาม",
		"gpsSyncQuery": "คำถามเกี่ยวกับการซิงโครไนซ์จีพีเอส",
		"dataAbnormal": "การยกเว้นข้อมูล",
		"vehicleLocation": "การหาตำแหน่งยานพาหนะ",
		"basicInformation": "ข้อมูลพื้นฐาน",
		"businessPartner": "คู่ค้าทางธุรกิจ",
		"platformAccount": "บัญชี",
		"organizationNumber": "หมายเลของค์กร",
		"platformKey": "กุณแจ",
		"sourceType": "ประเภทของแหล่งที่มา",
		"testTips": "ทดสอบว่าการกำหนดค่าถูกต้องหรือไม่",
		"test": "ทดสอบ",
		"plateNumber": "หมายเลขป้ายทะเบียน",
		"deviceNumber": "หมายเลขอุปกรณ์",
		"temperature": "อุณหภูมิ",
		"locationTime": "เวลาการหาตำแหน่ง",
		"location": "ตำแหน่ง",
		"addTrackingAccount": "เพิ่มบัญชีการติดตาม",
		"self": "ของตนเอง",
		"ownVehicle": "ยานพาหนะของตนเอง",
		"internalSharingVehicle": "ยานพาหนะร่วมภายใน",
		"externalSharingVehicle": "ยานพาหนะร่วมภายนอก",
		"accountOrKeyError": "ข้อผิดพลาดของบัญชีหรือกุญแจ",
		"checkTips": "กรุณาทดสอบการกำหนดค่าบัญชีนี้ก่อน",
		"g7OrganizationNumber": "สำหรับแพลตฟอร์ม g7 กรุณากรอกหมายเลขสถาบัน",
		"selectBusinessPartner": "กรุณาเลือกคู่ค้าทางธุรกิจ"
	},
	"synchronousQuery": {
		"asyncTime": "เวลาซิงโครไนซ์",
		"requestData": "เข้าถึงข้อมูล",
		"resultData": "ส่งคืนข้อมูล",
		"asyncInfo": "ข้อมูลการซิงโครไนซ์"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/number/number.js